import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";

const curriculumData = [
  {
    title: "Cloud Foundations & Virtualization Concepts",
    description:
      "cloud computing & why industries use it, Types of clouds: Public Private Hybrid, Service models: IaaS PaaS SaaS, Virtual machines hypervisors & container basics, Benefits: scalability elasticity reliability",
  },
  {
    title: "Networking & Infrastructure in the Cloud",
    description:
      "Virtual networks subnets & IP addressing, Load balancers NAT gateways & firewalls, DNS CDN & global traffic management, How cloud networking differs from traditional networking, Secure network architecture",
  },
  {
    title: "Storage, Databases & Backup Systems",
    description:
      "Object block & file storage (S3 Blob GCS), Database options: SQL vs NoSQL, Backup & snapshot strategies, Data lifecycle management, High availability & fault tolerance",
  },
  {
    title: "Compute Services & Serverless Architectures",
    description:
      "Object block & file storage (S3 Blob GCS), Database options: SQL vs NoSQL, Backup & snapshot strategies, Data lifecycle management, High availability & fault tolerance",
  },
  {
    title: "Identity, Access Management & Cloud Security",
    description:
      "IAM roles policies & permissions, MFA key management & secrets, Zero-trust security principles, Compliance & cloud governance, Securing cloud accounts from cyber threats",
  },
  {
    title: "DevOps & CI/CD in the Cloud",
    description:
      "DevOps philosophy & automation basics, CI/CD pipeline creation, GitHub Actions Jenkins or cloud-native CI tools, Infrastructure as Code (IaC) with Terraform/CloudFormation, Monitoring & logging for cloud reliability",
  },
  {
    title: "Cloud Application Development & Deployment",
    description:
      "Building cloud-native applications, API gateways & microservices, Container deployment & scaling, Environment management: Dev Test Production, Hands-on: Deploying a real app to cloud",
  },
  {
    title: "Cost Management & Cloud Optimization",
    description:
      "Building cloud-native applications, API gateways & microservices, Container deployment & scaling, Environment management: Dev Test Production, Hands-on: Deploying a real app to cloud, Pricing models of AWS/GCP/Azure, Cost calculators & budgeting tools, Resource tagging & automation, Optimization: autoscaling right sizing spot instances, Avoiding unnecessary resource usage",
  },
  {
    title: "Multi-Cloud & Hybrid Cloud Strategies",
    description:
      "companies choose multi-cloud, Interconnecting multiple cloud platforms, Disaster recovery planning, Data migration techniques, Industry examples of hybrid cloud",
  },
  {
    title: "Capstone Cloud Project & Career Preparation",
    description:
      "Deploying a full cloud architecture from scratch, Designing scalable & secure solutions, Documentation & presentation, Cloud resume building, Interview prep for Cloud Engineer DevOps Engineer Solution Architect",
  },
];

const ProgramCurriculum = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleSection = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="curriculum-container">
      <motion.h2
        className="curriculum-heading"
        initial={{ opacity: 0, y: -30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Program Curriculum
      </motion.h2>
      <motion.p
        className="curriculum-subtext"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.6 }}
      >
        This curriculum is structured in a practical and progressive format so
        you can learn step-by-step from zero to advanced level — and build
        real-world applications.
      </motion.p>
      <div className="curriculum-list">
        {curriculumData.map((item, index) => (
          <motion.div
            key={index}
            className="curriculum-item"
            onClick={() => toggleSection(index)}
            whileHover={{ x: 10 }}
            transition={{ duration: 0.3 }}
          >
            <div className="title-row">
              <span className="curriculum-title">{item.title}</span>
              <motion.span
                animate={{ rotate: activeIndex === index ? 90 : 0 }}
                transition={{ duration: 0.3 }}
                className="arrow"
              >
                ➤
              </motion.span>
            </div>
            <AnimatePresence>
              {activeIndex === index && (
                <motion.p
                  className="curriculum-description"
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  {item.description}
                </motion.p>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ProgramCurriculum;
